import { render, staticRenderFns } from "./book-unit-list.vue?vue&type=template&id=a4f0ccc0&"
import script from "./book-unit-list.vue?vue&type=script&lang=js&"
export * from "./book-unit-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports